// NOTE: if you add any filters that rely on model ids (for ex. product.segmentId, product.recommenderId, product.campaignId, etc.)
// don't forget to change domain-migration-helper in the API to replace source ids with destination ids in segment.rules[].filters[]!
const filters = {
  price: {
    name: 'Price',
    field: 'price',
    inputType: 'range',
    conditionType: 'floatRange',
    placeholder: ['e.g. 50', 'e.g. 99'],
  },
  discountPercent: {
    name: 'Discount %',
    field: 'discountPercent',
    inputType: 'range',
    conditionType: 'floatRange',
    min: 0,
    placeholder: ['e.g. 1', 'e.g. 20'],
  },
  discount: {
    name: 'Discount amount',
    field: 'discount',
    inputType: 'range',
    conditionType: 'floatRange',
    min: 0,
    placeholder: ['e.g. 50', 'e.g. 99'],
  },
  categories: {
    name: 'Categories',
    field: 'categories',
    inputType: 'string',
    conditionType: 'term',
  },
};

export default filters;
